import { Directive, inject, TemplateRef } from '@angular/core';

/**
 * Template markers for bz-table custom header / row markup.
 *
 * Both are plain TemplateRef holders, kept in one file because they only make sense as a pair.
 * The table renders them with ngTemplateOutlet rather than <ng-content select="...">, because
 * the projected .th / .td cells have to end up as direct flex children of the .tr row - any
 * wrapper element in between breaks the column layout.
 */

@Directive({
  selector: 'ng-template[bzTableHeader]'
})
export class BzTableHeaderDef {
  readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}

@Directive({
  selector: 'ng-template[bzTableRow]'
})
export class BzTableRowDef<T = unknown> {
  readonly templateRef = inject<TemplateRef<{ $implicit: T; index: number }>>(TemplateRef);
}
